import _sfc_main from './UiTabBar.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("nav", { staticClass: "fds-widget fds-ui-tab-bar" }, [_vm._t("root", function() {
    return [_c("ul", { staticClass: "fds-ui-tab-bar__list" }, [_vm._l(_vm.tabs, function(tab, index) {
      return [_vm._t(`item:${tab.key}`, function() {
        return [_vm._t("item", function() {
          return [_c("li", { key: `fds-ui-tab-bar-item-${index}`, staticClass: "fds-ui-tab-bar__item", class: { "fds-ui-tab-bar__item--active": _setup.isTabActive(tab) } }, [_vm._t("item:button", function() {
            return [_c("button", { staticClass: "fds-ui-tab-bar__button", class: { "fds-ui-tab-bar__button--disabled": _setup.isTabDisabled(tab) }, attrs: { "type": "button", "disabled": _setup.isTabDisabled(tab) }, on: { "click": function($event) {
              return _setup.changeTab(tab);
            }, "keyup": [function($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter"))
                return null;
              return _setup.changeTab(tab);
            }, function($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"]))
                return null;
              return _setup.changeTab(tab);
            }] } }, [_vm._t("item:button:content", function() {
              return [_vm._v(" " + _vm._s(tab.label) + " ")];
            }, null, { tab, index, value: _vm.value, tabs: _vm.tabs, isTabActive: _setup.isTabActive, isTabDisabled: _setup.isTabDisabled, changeTab: _setup.changeTab })], 2)];
          }, null, { value: _vm.value, tabs: _vm.tabs, isTabActive: _setup.isTabActive, isTabDisabled: _setup.isTabDisabled, changeTab: _setup.changeTab })], 2)];
        }, null, { value: _vm.value, tabs: _vm.tabs, isTabActive: _setup.isTabActive, isTabDisabled: _setup.isTabDisabled, changeTab: _setup.changeTab })];
      }, null, { value: _vm.value, tabs: _vm.tabs, isTabActive: _setup.isTabActive, isTabDisabled: _setup.isTabDisabled, changeTab: _setup.changeTab })];
    })], 2)];
  }, null, { value: _vm.value, tabs: _vm.tabs, isTabActive: _setup.isTabActive, isTabDisabled: _setup.isTabDisabled, changeTab: _setup.changeTab })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/ui-tab-bar/UiTabBar.vue";
var UiTabBar = __component__.exports;

export { UiTabBar as default };
